export const ContactPersonType = {
   isDefault: "Domyślny",
}

export const ContactPersonTypeColor = {
    isDefault: "info",
 }